module.exports = __webpack_public_path__ + "static/img_reverse@2x-33bdbbf87ca46f71641c055975f237e1.png";